import { startCase } from 'lodash';
import { Declaration } from 'store/declarations/declaration';
import { DeclarationCountry, getDeclrationCountry } from 'store/declarations/enums/common/declaration-country';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';

// "UK Export (B1)" / "Irish Import (H1)" - the one-line name of a mirrored declaration in the list.
export const getMirroredRowTypeLabel = (declaration: Declaration, messageType: string) => {
    const country = getDeclrationCountry(declaration);
    const countryText = country === DeclarationCountry.IRELAND ? 'Irish' : country.toUpperCase();

    const internalType = declaration.declarationInternalType;
    const isImport = internalType === DeclarationInternalType.IMPORT_NEW;
    const internalTypeText = isImport ? 'Import' : startCase(internalType?.toLowerCase());

    const messageTypeText = messageType ? `(${messageType})` : '';

    return [countryText, internalTypeText, messageTypeText].filter(Boolean).join(' ');
};
